export default {
  post(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/sales/checkout-build", params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/sales/checkout-build/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  // updateComponent(context, params) {
  //   return new Promise((resolve, reject) => {
  //     return window.axios
  //       .put(`/sales/checkout-build/component/${params.id}`, params)
  //       .then(resolve)
  //       .catch(reject);
  //   });
  // },
  deleteComponent(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/sales/checkout-build/component/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },

  setCheckoutState(context, checkout_build) {
    context.commit("setCheckoutBuilder", checkout_build);

    context.commit("setBackground", {
      color: checkout_build.config?.backgroundColor,
      image: checkout_build.background_image
    });

    const components = [...(checkout_build.components || [])];

    if (checkout_build.config?.countdown) {
      components.push({
        type: "timer",
        countdown: true,
        countdownTime: checkout_build.config?.countdownTime ?? 0
        // countdownText:
        //   checkout_build.config?.countdownText ?? "Essa oferta irá expirar...",
        // countdownTextColor:
        //   checkout_build.config?.countdownTextColor ?? "#FFFFFF",
        // countdownBackgroundColor:
        //   checkout_build.config?.countdownBackgroundColor ?? "#ee6469"
      });
    }
    context.commit("setComponents", components);
  },
  saveSnapshot(context) {
    const { components, background, snapshots } = context.state;
    context.commit("setSnapshots", [...snapshots, { components, background }]);
  },
  undoSnapshot(context) {
    const snapshots = [...context.state.snapshots];
    snapshots.pop();
    context.commit("setSnapshots", snapshots);
    if (snapshots.length) {
      context.commit(
        "setComponents",
        snapshots[snapshots.length - 1].components
      );
      context.commit(
        "setBackground",
        snapshots[snapshots.length - 1].background
      );
    } else {
      context.dispatch("setCheckoutState", context.state.checkoutBuilder);
    }
  }
};
